import { render, staticRenderFns } from "./TimeBasedSales.vue?vue&type=template&id=98039a4c&"
import script from "./TimeBasedSales.vue?vue&type=script&lang=js&"
export * from "./TimeBasedSales.vue?vue&type=script&lang=js&"
import style0 from "./TimeBasedSales.vue?vue&type=style&index=0&id=98039a4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports